<template>
<div class="chapter">
<div class="inner_page">
<h1 class="fm-title" id="fm-2"><a id="page_xi"><em>Tables</em></a></h1><a id="page_xi">
</a><p class="list-tables"><a id="page_xi"></a><span href="#/014_Chapter01#tab_1.1" title="Link target outside of Sample">1.1 <span class="pad-f">Julio-Claudian <em class="italic">Divi</em></span></span></p>
<p class="list-tables"><span href="#/014_Chapter01#tab_1.2" title="Link target outside of Sample">1.2 <span class="pad-f">Known Provincial Divine Honors for Julio-Claudians in the Greek East</span></span></p>
<p class="list-tables"><span href="#/015_Chapter02#tab_2.1" title="Link target outside of Sample">2.1 <span class="pad-f">Philippian <em class="italic">Flamines</em></span></span></p>
<p class="list-tables"><span href="#/015_Chapter02#tab_2.2" title="Link target outside of Sample">2.2 <span class="pad-f">Philippian <em class="italic">Sacerdotes</em> of <em class="italic">Diva</em> Augusta</span></span></p>
<p class="list-tables"><span href="#/015_Chapter02#tab_2.3" title="Link target outside of Sample">2.3 <span class="pad-f">Philippian <em class="italic">Augustales</em></span></span></p>
<p class="list-tables"><span href="#/016_Chapter03#tab_3.1" title="Link target outside of Sample">3.1 <span class="pad-f"><em class="italic">Parousia</em> in Paul’s Letters</span></span></p>
<p class="list-tables"><span href="#/017_Chapter04#tab_4.1" title="Link target outside of Sample">4.1 <span class="pad-f">Known Corinthian Tribes</span></span></p>
<p class="list-tables"><span href="#/017_Chapter04#tab_4.2" title="Link target outside of Sample">4.2 <span class="pad-f">Julio-Claudians Depicted on Corinthian Coinage</span></span></p>
<p class="list-tables"><span href="#/017_Chapter04#tab_4.3" title="Link target outside of Sample">4.3 <span class="pad-f">Schedule of the Isthmian, Caesarean, and Imperial Games from AD 51 to AD 67</span></span></p>
<p class="list-tables"><span href="#/017_Chapter04#tab_4.4" title="Link target outside of Sample">4.4 <span class="pad-f">Julio-Claudian <em class="italic">Agonothetae</em> from Corinth</span></span></p>
<p class="list-tables"><span href="#/017_Chapter04#tab_4.5" title="Link target outside of Sample">4.5 <span class="pad-f">Corinthian <em class="italic">Augustales</em></span></span></p>
<p class="list-tables"><span href="#/017_Chapter04#tab_4.6" title="Link target outside of Sample">4.6 <span class="pad-f">Julio-Claudian Statuary from Corinth’s Julian Basilica</span></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 007_Tables.vue?1168b43e